// angular
//     .module("HeroPRO")
//     .controller("FileUploadController", fileUploadController);

/* @ngInject */
export default function fileUploadController($scope) {
    const vm = this;

    vm.uploadFile = () => {
        $scope.processDropzone();
    };

    vm.reset = () => {
        $scope.resetDropzone();
    };

    vm.uploadButtonClicked = ($event) => {
        $event.preventDefault();
    };
}



// WEBPACK FOOTER //
// ./src/app/appDetail/documents/uploadDocumentsModal/fileUploadController.js